var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9514 9.50903V15.5549M10.919 9.50903V15.5549M1 5.47845H16.8704M15.8785 5.47845L15.0185 17.7133C14.9829 18.2217 14.7589 18.6976 14.3918 19.045C14.0246 19.3923 13.5414 19.5855 13.0397 19.5855H4.83072C4.32896 19.5855 3.84583 19.3923 3.47864 19.045C3.11146 18.6976 2.8875 18.2217 2.85188 17.7133L1.9919 5.47845H15.8785ZM11.9109 5.47845V2.45552C11.9109 2.18828 11.8064 1.93198 11.6204 1.74301C11.4344 1.55404 11.1821 1.44788 10.919 1.44788H6.9514C6.68833 1.44788 6.43604 1.55404 6.25002 1.74301C6.064 1.93198 5.9595 2.18828 5.9595 2.45552V5.47845H11.9109Z",
    stroke: "currentColor",
    strokeWidth: 1.60573,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.2e07b727e205679f327a3a285b1c96e7.svg";
export { ForwardRef as ReactComponent };